import React, { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const MoveEightHorizontal: FC<IconProps> = ({ width = 30, height = 30, fill = '#F7F7F7', className }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="30" height="30" rx="6" />
      <path
        d="M9.25 20.75C5.95 20.75 3.75 18.33 3.75 15C3.75 11.67 5.95 9.25 9.25 9.25C11.28 9.25 13.01 10.35 15 12.7C16.99 10.35 18.72 9.25 20.75 9.25C24.05 9.25 26.25 11.67 26.25 15C26.25 18.33 24.05 20.75 20.75 20.75C18.72 20.75 16.99 19.65 15 17.3C13.01 19.65 11.28 20.75 9.25 20.75ZM9.25 10.75C6.83 10.75 5.25 12.43 5.25 15C5.25 17.57 6.83 19.25 9.25 19.25C10.77 19.25 12.13 18.37 14.03 16.02C14.39 15.58 14.68 15.25 15 15.25C15.32 15.25 15.61 15.58 15.97 16.02C17.87 18.37 19.23 19.25 20.75 19.25C23.17 19.25 24.75 17.57 24.75 15C24.75 12.43 23.17 10.75 20.75 10.75C19.23 10.75 17.87 11.63 15.97 13.98C15.61 14.42 15.32 14.75 15 14.75C14.68 14.75 14.39 14.42 14.03 13.98C12.13 11.63 10.77 10.75 9.25 10.75Z"
        fill={fill}
      />
    </svg>
  );
};
